import React from "react";
import ReactDOM from "react-dom";
import Widget from "./Widget";
import '@fontsource/roboto';

const id = "tecobi-root";
let element = document.getElementById(id);
if (!element) {
  element = document.createElement("div");
  element.id = id;
  document.body.appendChild(element);
}

ReactDOM.render(<Widget />, element);

let tecobiMessageStyle =
  "font-size:21px; font-weight:200; letter-spacing:0.2em; line-height:1.4em; font-family:helvetica,arial; color:rgba(0,0,25,0.5);";
let asciiTecobi = `
  _______ ______ _____ ____  ____ _____
 |__   __|  ____/ ____/ __ \\|  _ \\_   _|
    | |  | |__ | |   | |  | | |_) || |
    | |  |  __|| |   | |  | |  _ < | |
    | |  | |___| |___| |__| | |_) || |_
    |_|  |______\\_____\\____/|____/_____|
`;
console.log(asciiTecobi);
console.log("%cConnect with Customers Instantly!", tecobiMessageStyle);
console.log("%chttps://www.tecobi.com/", tecobiMessageStyle);
console.log("%c", "font-size:34px; line-height:1.4em;");
